import { LoanExampleText } from '@/components/LoanExampleText/index.ts';

export const Disclaimer = () => {
  return (
    <div className="mx-auto mt-10 max-w-[700px] text-center text-xs leading-[1.4] text-v1-neutral-80 sm:text-sm">
      <LoanExampleText />
    </div>
  );
};

export default Disclaimer;
